import { useEffect } from "react";

/** Auto-dismiss in-app banner and toast surfaces. */
export function useEphemeralToasts(opts: {
  banner: unknown;
  toast: unknown;
  clearBanner: () => void;
  clearToast: () => void;
}): void {
  useEffect(() => {
    if (!opts.banner) return;
    // Shorter dwell + CSS fade near end (SEC-PUSH honesty: in-app only while unlocked).
    const t = window.setTimeout(opts.clearBanner, 4800);
    return () => window.clearTimeout(t);
  }, [opts.banner, opts.clearBanner]);

  useEffect(() => {
    if (!opts.toast) return;
    const t = window.setTimeout(opts.clearToast, 3800);
    return () => window.clearTimeout(t);
  }, [opts.toast, opts.clearToast]);
}
